export const STATEMENTS = Object.freeze({
  visie: {
    order: 1,
  },
  medewerkers: {
    order: 2,
  },
  classificatiemodel: {
    order: 3,
  },
  governanceplan: {
    order: 4,
  },
  richtlijn: {
    order: 5,
  },
  crisissimulatie: {
    order: 6,
  },
  afhankelijkheden: {
    order: 7,
  },
});

export const STATEMENT_KEYS = Object.entries(STATEMENTS)
  .sort(([, v1], [, v2]) => v1.order - v2.order)
  .map(([k]) => k);
